// Fully diluted share count — PSD §4.2.1 (F1.4). Engine layer (framework-free).
/**
 * Computes the single canonical fully diluted denominator used in all per-share math.
 * common/preferred/rsu/option/warrant add outstanding shares; pool adds unissued portion
 * (authorized - outstanding). Convertibles ignored in Phase 1 (handled separately as
 * as-converted at exit in Phase 2). All-zero cap table returns 0.
 */
export function fullyDilutedShares(cap) {
    let total = 0;
    for (const inst of cap.instruments) {
        total += instrumentDilutiveShares(inst);
    }
    return total;
}
/** Dilutive share contribution of a single instrument. */
export function instrumentDilutiveShares(inst) {
    switch (inst.kind) {
        case 'common':
        case 'preferred':
        case 'rsu':
        case 'option':
        case 'warrant':
            return Math.max(0, inst.sharesOutstanding);
        case 'pool':
            return Math.max(0, inst.sharesAuthorized - inst.sharesOutstanding);
        case 'convertible':
            return 0; // convertibles handled separately (Phase 2)
        default:
            return 0;
    }
}
//# sourceMappingURL=fullyDiluted.js.map